

module.exports = __webpack_require__.stylable.create(
    "GroupCardMedia1516949526",
    {"classes":{"root":"GroupCardMedia1516949526__root","empty":"GroupCardMedia1516949526__empty","image":"Image193665631__image"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    3,
    "GroupCardMedia1516949526",
    null
);
